
import { Table, TableBody, ButtonGroup, Modal, TableCell, TableContainer, TableHead, TableRow,  AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider,  CssBaseline, } from "@mui/material";
import { useState, useEffect } from "react";

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import Close from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';

import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import Searchicon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import AddNewStore from "../../stores/master/AddStoreList";





const StoreMaster = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Godown');
    const [selectedMenuFirst, setSelectedMenuFirst] = useState('Bulk Update');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const openFirst = Boolean(anchorElFirst);
    const [newStore, setNewStore] = useState(false);
    const [storeHome, setStoreHome] = useState(true);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);



    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [anchorElMenu, setAnchorElMenu] = useState(null);
    const openMenu = Boolean(anchorElMenu);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Godown') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Godown') {
            setSelectedStatus('Active Godown');
        }
        else if (option === 'In Active Godown') {
            setSelectedStatus('In Active Godown');
        }




        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const [editStoreID, setEditStoreID] = useState(0);

    const handleShowNewVendor = () => {
        setEditStoreID(0);
        setStoreHome(false);
        setNewStore(true);
    }

    const handleCallEdit = (value) => {
        setEditStoreID(value);

        setStoreHome(false);
        setNewStore(true);
    };

    const handlecallback = () => {
        setStoreHome(true);
        setNewStore(false);
        loadStoreList();

    }

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [employeeDetails, setemployeeDetails] = useState([]);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }


            callApi(API_ENDPOINTS.Example_Employee_form, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setemployeeDetails(data);

                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);



    const [data, setData] = useState([]);

    useEffect(() => {
        if (!isDataLoaded) {
            loadStoreList();
        }
    }, [isDataLoaded]);

    const loadStoreList = async () => {
        let company_id = localStorage.getItem('companyid');
        const para = {
            p_companyid: company_id,
            p_plantid: 1
        }

        await callApi(API_ENDPOINTS.STORE_GET_STORE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setData(data);
                }
            })
            .catch(error => {
                alert(error.message);
            });
    }


    const [open, setOpen] = useState(false);
    const [filters, setFilters] = useState({
        p_store_code: '',
        p_name: '',
        p_address: '',
        p_status: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = data.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;



    const filteredData = data.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleNewToolbarClose = () => {
        setShowNewToolbar(false); // Hide new toolbar
        setShowFirstToolbar(true);
    };

    const handleBulkUpdate = () => {
        console.log('Bulk Update');
    };

    const handleMarkAsIssued = () => {
        console.log('Mark as Issued');
    };

    const handleBulkCancelItems = () => {
        console.log('Bulk Cancel Items');
    };

    const handleBulkReopenCancelledItems = () => {
        console.log('Bulk Reopen Cancelled Items');
    };

    const handleConvertToBill = () => {
        console.log('Convert to Bill');
    };

    // State for Dropdown Menu



    // Menu Handlers
    const handleMenuOpen = (event) => {
        setAnchorElMenu(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorElMenu(null);
    };

    return (
        <Box >
            <CssBaseline />
            {storeHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        {showFirstToolbar && (
                            <>
                                <Button
                                    color="secondary"
                                    onClick={handleMenuClickFirst}
                                    endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                >
                                    {selectedOptionFirst}
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('All Godown')}>All </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('Active Godown')}>Active Godown</MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickFirst('In Active Godown')}>In Active Godown</MenuItem>

                                </Menu>

                                {/* Adding margin-left: auto to push the button to the right */}
                                <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                                {/* Second Menu */}
                                <IconButton
                                    size="small"
                                    // edge="start"
                                    color="secondary"
                                    aria-label="menu"
                                    sx={{ ml: 2 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <MoreVertIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorElSecond}
                                    open={openSecond}
                                    onClose={handleMenuCloseSecond}
                                >
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Godown')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Godown" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Godown')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Godown" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <IconButton
                                    size="small"
                                    // edge="start"
                                    // color="inherit"
                                    aria-label="menu"
                                    sx={{ mr: 1, ml: 1 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <HelpIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                                    </IconButton>
                                </div>
                            </>
                        )}

                        {showNewToolbar && (
                            <>
                                <Button
                                    variant="outlined"
                                    color="secondary"

                                    onClick={handleMenuClickFirst}
                                    endIcon={<ArrowDropDownIcon sx={{ color: "teal" }} />}
                                    sx={{ textTransform: 'none', fontSize: "10px", fontWeight: "bold" }}
                                >
                                    {/* {selectedOptionFirst} */}
                                    <Typography variant="h6">
                                        Bulk Updates
                                    </Typography>
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleBulkUpdate()}>Bulk Update </MenuItem>
                                    <MenuItem onClick={() => handleMarkAsIssued()}>Mark as Issued</MenuItem>
                                    <MenuItem onClick={() => handleBulkCancelItems()}>Bulk Cancel Items</MenuItem>
                                    <MenuItem onClick={() => handleBulkReopenCancelledItems()}>Bulk reopen Canceled items</MenuItem>
                                    <MenuItem onClick={() => handleConvertToBill()}>Convert to Bill</MenuItem>
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Billed Purchase Orders')}>Billed</MenuItem> */}
                                </Menu>



                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="email" sx={{ padding: "6px", minWidth: 40 }}>
                                        <EmailIcon style={{ fontSize: "20px", color: "#5c6bc0" }} />
                                    </Button>
                                    <Button aria-label="pdf" sx={{ padding: 0, minWidth: 40 }}>
                                        <PictureAsPdfIcon style={{ fontSize: "20px", color: "#d32f2f" }} />
                                    </Button>
                                    <Button aria-label="print" sx={{ padding: 0, minWidth: 40 }}>
                                        <PrintIcon style={{ fontSize: "20px", color: "#64b5f6" }} />
                                    </Button>
                                </ButtonGroup>
                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="delete" sx={{ padding: "6px", minWidth: 40 }}>
                                        <DeleteIcon style={{ fontSize: "20px", color: "#ff7043" }} />
                                    </Button>
                                </ButtonGroup>
                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 2 }} >
                                    <FiberManualRecordIcon sx={{ fontSize: "12px", color: "green" }} />
                                </IconButton>
                                <Typography variant="h6" >
                                    {`${selectedRows.length} Purchase Order${selectedRows.length > 1 ? 's' : ''} selected`}
                                </Typography>


                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 'auto', mr: 1 }} onClick={handleNewToolbarClose}>
                                    <CloseIcon />
                                </IconButton>
                            </>
                        )}




                    </Toolbar>
                </AppBar>



            )}

            {storeHome && (

                <Box
                    gridColumn="span 9"
                    gridRow={"span 2"}
                    alignItems="center"
                    justifyContent="center"
                    padding={1}
                    sx={{
                        "& .MuiTable-root": {
                            border: "none",
                            size: "small",
                        },
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                            // fontWeight: "bold",
                            border: "1px solid ",
                            borderColor: `${colors.primary[400]} !important`,
                        },
                        "& .name-column--cell": {
                            color: colors.greenAccent[300],
                        },
                        "& .MuiTableHead-root": {
                            // backgroundColor: colors.blueAccent[700],
                            borderBottom: "none",


                        },
                        "& .MuiTableBody-root": {
                            overflowY: "auto",
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.blueAccent[200]} !important`,
                            size: "small",
                        },
                        "& .MuiTableFooter-root": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[700],
                            height: "10px",
                        },
                        "& .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },

                    }}>

                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell>Godown Code</TableCell>
                                    <TableCell>Godown Name</TableCell>
                                    <TableCell>Address</TableCell>
                                    <TableCell>Status</TableCell>

                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="Godown Code"
                                                    name="store_code"
                                                    value={filters.store_code}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Godown Name"
                                                    name="name"
                                                    value={filters.name}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Address"
                                                    name="address"
                                                    value={filters.address}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />
                                                <TextField
                                                    label="Status"
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                />

                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.id_store}>

                                        <TableCell>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row.id_store)}
                                            >
                                                {row.store_code}
                                            </span>
                                        </TableCell>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.address}</TableCell>
                                        <TableCell>{row.status}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}


            {/* New Vendor */}
            {newStore && (
                <>
                    <AddNewStore handlecallback={handlecallback} editStoreID={editStoreID} />
                </>

            )}



        </Box>
    );
}

export default StoreMaster;





